<template>
  <div class="comprehensive_evaluation">
    <div class="menu_list flex">
      <div class="menu_one flex flexcolumn Flexalign cursor_pointer" v-for="(item, index) in menuList" :key="index"
        @click="chaneMenu(item)" :class="[item.value == selectMenu ? 'text_active' : '']">
        {{ item.label }}
        <div :class="[item.value == selectMenu ? 'line_active' : '']"></div>
      </div>
    </div>
    <!-- 学习进度 -->
    <studyProgress v-if="selectMenu == 1" :courseDetail="courseDetail"></studyProgress>
    <!-- 学习习惯 -->
    <studyHabits v-if="selectMenu == 2" :courseDetail="courseDetail"></studyHabits>
    <!-- 平时测试 -->
    <regularTest v-if="selectMenu == 3" :courseDetail="courseDetail"></regularTest>
    <!-- 综合分析 -->
    <comprehensiveAnalysis v-if="selectMenu == 4"></comprehensiveAnalysis>
  </div>
</template>

<script>
import studyProgress from "./evaluation/studyProgress.vue";
import studyHabits from "./evaluation/studyHabits.vue";
import regularTest from "./evaluation/regularTest.vue";
import comprehensiveAnalysis from "./evaluation/comprehensiveAnalysis.vue";
export default {
  name: "GjkcH5ComprehensiveEvaluation",
  components: {
    studyProgress,
    studyHabits,
    regularTest,
    comprehensiveAnalysis,
  },
  props: {
    courseDetail: {},
  },

  data() {
    return {
      menuList: [
        { label: "学习进度", value: 1 },
        { label: "学习习惯", value: 2 },
        { label: "平时测试", value: 3 },
        { label: "综合分析", value: 4 },
      ],
      selectMenu: 1,
    };
  },

  mounted() { },

  methods: {
    chaneMenu(info) {
      this.selectMenu = info.value;
    },
  },
};
</script>

<style lang="scss" scoped>
.comprehensive_evaluation {
  width: 762px;
  min-height: 882px;
  background: #ffffff;
  border-radius: 10px;
  padding: 0 20px;
  box-sizing: border-box;
  margin-bottom: 30px;

  .menu_list {
    border-bottom: 1px solid rgba(20, 20, 20, 0.1);

    .menu_one {
      line-height: 50px;
      margin: 0 10px;
      position: relative;
    }

    .line_active {
      position: absolute;
      bottom: 0;
      width: 20px;
      height: 2px;
      background: #13d6aa;
    }
  }
}
</style>
